/**
 * 매장 상세 단독 페이지 (/business/:companySeq)
 *
 *  본문은 매장 목록 우측 패널과 동일한 탭 컴포넌트를 그대로 사용한다.
 *  (딥링크·기존 북마크 호환용)
 */
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PageHeader, ErrorState } from '@/components/common';
import { BusinessDetailPanel } from './BusinessDetailPanel';

const BusinessDetail = () => {
  const { companySeq } = useParams<{ companySeq: string }>();
  const navigate = useNavigate();

  const seq = Number(companySeq);

  return (
    <div className="flex h-[calc(100vh-120px)] flex-col">
      <div className="shrink-0">
        <PageHeader
          title="매장 상세"
          right={
            <button
              type="button"
              onClick={() => navigate('/business')}
              className="inline-flex items-center gap-1 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              <ArrowLeft size={16} />
              목록으로
            </button>
          }
        />
      </div>

      <div className="mt-4 min-h-0 flex-1">
        {!companySeq || Number.isNaN(seq) ? (
          <ErrorState error="매장 정보를 찾을 수 없습니다." />
        ) : (
          <BusinessDetailPanel companySeq={seq} />
        )}
      </div>
    </div>
  );
};

export default BusinessDetail;
